export const SECURITY_CHANGE_PIN = "SECURITY/change_pin";
export const SECURITY_CHANGE_PASSWORD = "SECURITY/change_password";

export const VALIDATE_PASSWORD = "SECURITY/validate_password";
